webpackJsonp([2],{

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  review: {
    color: 'blue',
    fontSize: '18px',
    fontStyle: 'italic'

  }

};

exports.default = function () {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h1',
        null,
        _react2.default.createElement(
          'b',
          null,
          'See what people have to say about us'
        )
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('img', { src: '/images/siemens_logo.jpg', alt: 'siemens' }),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'h2',
        null,
        'Siemens Medical Solutions, USA.'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'p',
        { style: styles.review },
        '"We just completed what is arguably the most complex project we have ever done outside the US \u2013 Definition CT and Aera MR Installations for Camp Humphreys, in Pyeongtaek, South Korea. The Army is consolidating Korean Operations, which led to a need for a new hospital at Camp Humphreys (40 miles south of Seoul). Siemens was awarded the gear and DCS (Design & Construction Services \u2013 Siemens Turn Key Projects) - contracts to finish the 2 rooms. ',
        _react2.default.createElement(
          'b',
          null,
          'Robert Hamm (Siemens DCS Director) selected Caffey Construction, a key DCS partner, to coordinate all on-site upfit activities over a 10 month period. '
        ),
        ' Without Robert\u2019s team, and his oversight, this project would have been unbearable."'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Siemens Healthineers Supply Chain Newsletter, Vol. 2, January 25, 2019'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'p',
        { style: styles.review },
        'Hello Jerry and Caffey Const.',
        _react2.default.createElement('br', null),
        'Its not too often that we get some recognition for a job well done so I wanted to extend my heart felt appreciation to you and all of the team that worked on this project. I know it took a toll on me and I didn\u2019t even do much of the work!! We had some trying moments working within a foreign country thousands of miles from home, trying to meet customer demands, and came thru it with great success because of all of your teams efforts to make this happen. I still remember the first notice we received that was a phone call with the Siemens sales and the customer asking us to have a proposals back to them in 24 hours site unseen. You guys awesome!!!!!!!!',
        _react2.default.createElement('br', null),
        'Thanks for all that you do.'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Robert Hamm, PMP Director of Design Construction Services, Solution Implementation (SI) Siemens Healthineers'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('img', { src: '/images/keesler_logo.png', alt: 'keesler-logo' }),
      _react2.default.createElement(
        'h2',
        null,
        'Keesler Air Force Base Medical Center'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement('img', { src: '/images/keeslernews.jpg', alt: 'keesler-news-article' }),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null)
    )
  );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Testimonials.51163c85.js